import { Directive, ElementRef, Injector, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudDataSource, CrudListComponent, FormStorage, UserStorage } from '@scisys-uim/uim-common';
import { AssetsUser, MECHANICAL_ASPECT_TYPE, MechanicalAspect, RefCode } from 'assets-model';
import { MechanicalAspectDataSource, MechanicalAspectService, RefCodeStorage } from 'assets-service';


@Directive()
export abstract class MechanicalAspectSearchComponentBase extends CrudListComponent<MechanicalAspect, number> {
  protected systemConfig: any;

  displayedColumns: string[] = [ 'aspectAssetId', 'havs', 'havsRagStatus', 'lockVersion', 'wbv', 'wbvRagStatus', 'actions'];

  public searchForm: FormGroup;

  aspectAssetIdFilter: number;
  @ViewChild('aspectAssetIdFilterInput') aspectAssetIdFilterInput: ElementRef;

  havsFilter: boolean;
  @ViewChild('havsFilterInput') havsFilterInput: MatSelect;

  havsRagStatusSelectionList: RefCode[];
  havsRagStatusFilter: string;
  @ViewChild('havsRagStatusFilterInput') havsRagStatusFilterInput: MatSelect;

  wbvFilter: boolean;
  @ViewChild('wbvFilterInput') wbvFilterInput: MatSelect;

  wbvRagStatusSelectionList: RefCode[];
  wbvRagStatusFilter: string;
  @ViewChild('wbvRagStatusFilterInput') wbvRagStatusFilterInput: MatSelect;


  get eAssetsUser(): AssetsUser {
    return AssetsUser.assignAs(this.userDetails);
  }

  constructor(protected route: ActivatedRoute,
    protected router: Router,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected mechanicalAspectService: MechanicalAspectService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected formStorage: FormStorage,
    protected injector: Injector) {
    super(MECHANICAL_ASPECT_TYPE, route, router, userStorage, dialog, mechanicalAspectService, injector);

    this.searchForm = this.fb.group({
      aspectAssetId: [null],
      havs: [null],
      havsRagStatus: [null],
      wbv: [null],
      wbvRagStatus: [null]
    });
  }

  createDataSource(): CrudDataSource<MechanicalAspect> {
    return new MechanicalAspectDataSource(this.mechanicalAspectService);
  }

  createServiceArguments(): any {
    return {
      aspectAssetId: this.aspectAssetIdFilter,
      havs: this.havsFilter,
      havsRagStatus: this.havsRagStatusFilter,
      wbv: this.wbvFilter,
      wbvRagStatus: this.wbvRagStatusFilter
    };
  }
  
  clearFiltersBeforeLoadPage() {
    this.restoreFormFromParams(this.searchForm);
  }
  
  clearFilterVariables() {
    this.aspectAssetIdFilter = null;
    this.havsFilter = null;
    this.havsRagStatusFilter = null;
    this.wbvFilter = null;
    this.wbvRagStatusFilter = null;
  }
  
  clearFilters() {
    this.clearFilterVariables();
    this.clearFiltersBeforeLoadPage();
    this.loadPage();
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
    this.addSearchOnChangedInputEventListener(this.aspectAssetIdFilterInput);
    this.addSearchOnChangedSelectEventListener(this.havsFilterInput);
    this.addSearchOnChangedSelectEventListener(this.havsRagStatusFilterInput);
    this.addSearchOnChangedSelectEventListener(this.wbvFilterInput);
    this.addSearchOnChangedSelectEventListener(this.wbvRagStatusFilterInput);
    this.formStorage.rememberFormChanges(this.searchForm);
  }

  ngOnInit() {
    super.ngOnInit();
  }
  
  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();
  }

  protected initExportOptions(config: any): any {
    config = config || {};
    return config;
  }

  protected initConfig(config: any) {
    super.initConfig(config);
    this.systemConfig = this.initExportOptions(config);
  }
  
  protected transformAllPropertiesToModelSetters(): {
    [key: string]: (value: any, formControl: FormControl, formControlName: string) => void
  } {
    const self = this;
    return {
      aspectAssetId: (value: number) => self.aspectAssetIdFilter = value,
      havs: (value: boolean) => self.havsFilter = value,
      havsRagStatus: (value: string) => self.havsRagStatusFilter = value,
      wbv: (value: boolean) => self.wbvFilter = value,
      wbvRagStatus: (value: string) => self.wbvRagStatusFilter = value
    }
  }
  
  restoreFormChanges() {
    const self = this;

    // IMPORTANT that the restoreFormChanges call occurs before the initial search - typically best done in onInitAsyncComplete
    // Whereever a form control binds with [ngModel] to a reactive form, ngModel takes precedence,
    // and needs it's own setter function to set the scope attribute bound
    this.formStorage.restoreFormChanges(this.searchForm, this.transformAllPropertiesToModelSetters());
  }

  aspectAssetIdChanging(value: number, unsetDependents: boolean = true) {}
  
  aspectAssetIdChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  havsChanging(value: boolean, unsetDependents: boolean = true) {}
  
  havsChanged(value: boolean, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  havsRagStatusLoadSelectionList() {
    this.refCodeStorage.getDomainElements('RAG_STATUS').subscribe(
      data => {
        this.havsRagStatusSelectionList = data;
      }
    );
  }

  havsRagStatusChanging(value: string, unsetDependents: boolean = true) {}
  
  havsRagStatusChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  wbvChanging(value: boolean, unsetDependents: boolean = true) {}
  
  wbvChanged(value: boolean, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  wbvRagStatusLoadSelectionList() {
    this.refCodeStorage.getDomainElements('RAG_STATUS').subscribe(
      data => {
        this.wbvRagStatusSelectionList = data;
      }
    );
  }

  wbvRagStatusChanging(value: string, unsetDependents: boolean = true) {}
  
  wbvRagStatusChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  disabledTooltip(element) {
    if (!element) {
      return true;
    }
    return element.valid || !element.touched;
  }

  get aspectAssetId() {
    return this.searchForm && this.searchForm.get('aspectAssetId');
  }

  get havs() {
    return this.searchForm && this.searchForm.get('havs');
  }

  get havsRagStatus() {
    return this.searchForm && this.searchForm.get('havsRagStatus');
  }

  get wbv() {
    return this.searchForm && this.searchForm.get('wbv');
  }

  get wbvRagStatus() {
    return this.searchForm && this.searchForm.get('wbvRagStatus');
  }


}



